import React, { useEffect, useState } from "react";
// import Navbar from "../components/Navbar";
import Footer1 from "../components/Footer1";
import MobileNav from "../components/MobileNav";
import { motion } from "framer-motion";
import "./Contact.css";

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contactNumber: "", // Added Contact Number
    subject: "",
    message: ""
  });

  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // Added loading state

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const scriptURL = "https://script.google.com/macros/s/AKfycbyxKkez2YjfSVj4P-iT6hF5S_tUqVbtjiy6yU6_uZlTnEZq7D8-srg_U2PGKpzNBTklTQ/exec"; 

    // Create a standard JSON object
    const payload = {
      name: formData.name,
      email: formData.email,
      contactNumber: formData.contactNumber,
      subject: formData.subject,
      message: formData.message
    };

    try {
      await fetch(scriptURL, { 
        method: "POST", 
        // Send as a JSON string
        body: JSON.stringify(payload), 
        // Use text/plain to bypass strict CORS preflight checks in browsers
        headers: {
            "Content-Type": "text/plain;charset=utf-8",
        }
      });
      
      setSubmitted(true);
      setFormData({ name: "", email: "", contactNumber: "", subject: "", message: "" });
    } catch (error) {
      console.error("Error!", error.message);
      alert("Something went wrong while sending your message. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Animation Variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  };

  return (
    <>
      <MobileNav />
      {/* <Navbar /> */}

      <div className="contact-page">
        
        {/* --- HERO SECTION --- */}
        <section className="contact-hero">
          <div className="contact-hero-overlay">
            <motion.h1 
              initial={{ y: 30, opacity: 0 }} 
              animate={{ y: 0, opacity: 1 }} 
              transition={{ duration: 1 }}
            >
              Get in Touch
            </motion.h1>
            <motion.p 
              initial={{ y: 30, opacity: 0 }} 
              animate={{ y: 0, opacity: 1 }} 
              transition={{ duration: 1, delay: 0.2 }}
            >
              Commission Requests • Collaborations • General Inquiries
            </motion.p>
          </div>
        </section>

        {/* --- MAIN CONTENT --- */}
        <div className="contact-container">
          <motion.div 
            className="contact-grid"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={staggerContainer}
          >
            
            {/* LEFT: Contact Info */}
            <motion.div className="contact-info" variants={fadeInUp}>
              <div className="info-header">
                <span className="subtitle">Connect</span>
                <h2>We'd love to hear from you</h2>
                <p>
                  Whether you are interested in a specific masterpiece, looking for a custom commission, 
                  or simply want to discuss art, our team is here to assist you.
                </p>
              </div>

              <div className="info-items">
                <div className="info-item">
                  <div className="icon-box"><i className="fa-solid fa-envelope"></i></div>
                  <div>
                    <h5>Email Us</h5>
                    <p>anjaanvivek17@gmail.com</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="icon-box"><i className="fa-solid fa-phone"></i></div>
                  <div>
                    <h5>Call Us</h5>
                    <p>+91 93008 47841</p>
                    <p>Mon-Sat, 10am - 7pm</p>
                  </div>
                </div>
              </div>

              <div className="social-links">
                <a href="https://www.instagram.com/anjaanvivek_art/" target="_blank" rel="noreferrer" className="social-icon"><i className="fa-brands fa-instagram"></i></a>
                <a href="https://www.facebook.com/vivek.verma.590410" target="_blank" rel="noreferrer" className="social-icon"><i className="fa-brands fa-facebook-f"></i></a>
                <a href="https://x.com/anjaanVivek" target="_blank" rel="noreferrer" className="social-icon"><i className="fa-brands fa-twitter"></i></a>
              </div>
            </motion.div>

            {/* RIGHT: Contact Form */}
            <motion.div className="contact-form-wrapper" variants={fadeInUp}>
              {submitted ? (
                <motion.div 
                    className="success-message"
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                >
                    <i className="fa-solid fa-circle-check"></i>
                    <h3>Message Sent!</h3>
                    <p>Thank you for reaching out. We will get back to you shortly.</p>
                    <button onClick={() => setSubmitted(false)} className="btn-reset">Send Another</button>
                </motion.div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Your Name</label>
                        <input 
                            type="text" 
                            name="name" 
                            value={formData.name} 
                            onChange={handleChange} 
                            placeholder="John Doe" 
                            required 
                        />
                    </div>
                    <div className="form-group">
                        <label>Email Address</label>
                        <input 
                            type="email" 
                            name="email" 
                            value={formData.email} 
                            onChange={handleChange} 
                            placeholder="john@example.com" 
                            required 
                        />
                    </div>
                    
                    {/* NEW CONTACT NUMBER FIELD */}
                    <div className="form-group">
                        <label>Contact Number</label>
                        <input 
                            type="tel" 
                            name="contactNumber" 
                            value={formData.contactNumber} 
                            onChange={handleChange} 
                            placeholder="+91 98765 43210" 
                            required 
                        />
                    </div>

                    <div className="form-group">
                        <label>Subject</label>
                        <select name="subject" value={formData.subject} onChange={handleChange} required>
                            <option value="">Select a Topic</option>
                            <option value="Commission">Commission Request</option>
                            <option value="Purchase">Purchase Inquiry</option>
                            <option value="Collaboration">Collaboration</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Message</label>
                        <textarea 
                            name="message" 
                            rows="4" 
                            value={formData.message} 
                            onChange={handleChange} 
                            placeholder="How can we help you?" 
                            required 
                        ></textarea>
                    </div>
                    <button type="submit" className="btn-send" disabled={isSubmitting}>
                      {isSubmitting ? "Sending..." : "Send Message"}
                    </button>
                </form>
              )}
            </motion.div>

          </motion.div>
        </div>
      </div>
      <Footer1 />
    </>
  );
};

export default Contact;